import React, { useRef, useEffect, useState } from 'react';
// components
import ItemHeader from './ItemHeader';
import ModalSetImg from './ModalSetImg';

const ImageCard = ({
    el,
    itemsIdx,
    outputsEl,
    callbackFromParent,
    callBackhandleItem,
    hasItem,
}) => {
    // state
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOverflowModal, setOverflowModal] = useState(false);

    // 모달
    const modalNode = useRef();
    // 모달 열기
    const openModal = () => {
        let ItemSetButtonPos = modalNode.current.getBoundingClientRect();
        let contentsWrap = modalNode.current.offsetParent.getBoundingClientRect();
        if (contentsWrap.right - ItemSetButtonPos.right < 241) {
            setOverflowModal(true);
        }
        setIsOpenModal(!isOpenModal);
    };
    // 모달 닫기
    const closeSet = (e) => {
        if (modalNode.current.contains(e.target)) {
            // inside click
            return;
        }
        setIsOpenModal(false);
    };
    // 모달 닫기
    useEffect(() => {
        // add when mounted
        document.addEventListener('mousedown', closeSet);
        // return function to be called when unmounted
        return () => {
            document.removeEventListener('mousedown', closeSet);
        };
    }, []);

    // 이미지  url
    let bgImgUrl = '';
    if (el.thumbnail) {
        bgImgUrl = el.thumbnail.imageUrl;
    }
    // 이미지  url 콜백
    const changeImgUrl = (imgUrl) => {
        bgImgUrl = imgUrl;
        if (!el.thumbnail) {
            el.thumbnail = {};
        }
        el.thumbnail.imageUrl = bgImgUrl;
        callbackFromParent(bgImgUrl);
    };
    // 버튼 백그라운드 이미지
    const btnBgStyle = {
        backgroundImage: 'url(' + bgImgUrl + ')',
    };

    return (
        <div className="item-cont">
            <ItemHeader
                itemsIdx={itemsIdx}
                callBackhandleItem={callBackhandleItem}
                hasItem={hasItem}
            />
            <div className="item img" ref={modalNode}>
                <button type="button" style={btnBgStyle} onClick={openModal}>
                    {!bgImgUrl ? '+ 이미지 등록 ' : '　'}
                    {!bgImgUrl && <span>*</span>}
                </button>
                {isOpenModal && (
                    <ModalSetImg
                        outputsEl={outputsEl}
                        changeImgUrl={changeImgUrl}
                        isOverflowModal={isOverflowModal}
                        isCarousel={false}
                        el={el}
                        callbackFromParent={callbackFromParent}
                    />
                )}
            </div>
        </div>
    );
};

export default ImageCard;
